import {
  selectAiPersona as selectAiPersonaImpl,
  selectHasUnlimitedChat,
  selectHasVoiceAccess,
  selectOracleToastDismissedContentId,
} from './selectors'

export { selectHasUnlimitedChat, selectHasVoiceAccess, selectOracleToastDismissedContentId }
export { setOraclePersona, setOracleGuideToastDismissed } from './actions'

// Locally re-bound rather than re-exported via `export { ... } from './selectors'`.
// Tests (PostHogProvider.unit.tsx) use `td.replace` against this export; a direct
// re-export produces a getter-only binding that testdouble cannot replace, whereas
// a local `const` re-binding gives testdouble a property it can swap.
export const selectAiPersona = selectAiPersonaImpl

export const PERSONALITY_ARCHITECT_ID = 1
export const PERSONALITY_SAGE_ID = 2
export const DEFAULT_PERSONALITY_ID = PERSONALITY_SAGE_ID
